// import BN from 'bn.js';

import { ButtonWrapper, Button } from 'components/common/button/button';
import OPNCard from 'components/cards/token-card/opn-card/opn-card';
import OCCCard from 'components/cards/token-card/occ-card/occ-card';
import GreenCoinIcon from 'components/icons/GreenCoinIcon';

import { useModal } from 'components/modal-views/context';
import { useAppDispatch } from 'redux/use-hooks';
import {
  actions as tokensSliceActions,
} from 'redux/slices/tokens';
const { setActiveTab, setActiveToken } = tokensSliceActions;
import { formatToken } from 'components/wallet/token-amount';

import { tabsOptions } from 'lib/constants';
import { TokenType } from 'types';

import {
  StyledCard,
  StyledValue,
  StyledGreenCoin,
  StyledGreenCoinMount,
  StyledFlexGrow
} from './token-card.style';

const getCardComponent = (token: TokenType) => {
  switch (token.onChainFTMetadata.symbol) {
    case 'OPN':
      return <OPNCard token={token} />;
    case 'OCC':
      return <OCCCard />;
    default:
      return null;
  }
};

const TokenCard = ({ token }: { token: TokenType }) => {
  const {
    onChainFTMetadata: { symbol,decimals },
    balance
  } = token;

  const finalBalance = balance;

  // if (symbol === 'OPN') {
  //   finalBalance = new BN(finalBalance).add(new BN(lockedBalance)).toString();
  // }
  const { openModal } = useModal();
  const dispatch = useAppDispatch();

  const onClickHandler = async (activeItem: TokenType, key: number) => {
    dispatch(setActiveToken(activeItem));
    dispatch(setActiveTab(tabsOptions[key]));
    openModal('SEND_VIEW');
  };

  return (
    <StyledCard>
      <StyledGreenCoin>
        <GreenCoinIcon />
        <StyledGreenCoinMount>{symbol}</StyledGreenCoinMount>
      </StyledGreenCoin>
      <StyledValue>{formatToken(finalBalance, decimals)}</StyledValue>
      <StyledFlexGrow>{getCardComponent(token)}</StyledFlexGrow>
      <ButtonWrapper>
        <Button fullwidth onClick={() => onClickHandler(token, 0)}>
          Send
        </Button>
        <Button fullwidth onClick={() => onClickHandler(token, 1)}>
          Receive
        </Button>
      </ButtonWrapper>
    </StyledCard>
  );
};

export default TokenCard;
